// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-menu .sidebar-header {
  margin-bottom: 0.8rem;
}
.sidebar-menu .current {
  border-bottom: 4px solid white;
}
.sidebar-menu .menu.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.sidebar-menu .menu.navbar-nav i {
  width: 25px;
  text-align: center;
}
.sidebar-menu .menu.navbar-nav hr.sidebar-divider {
  border-top: 1px dashed hsla(0, 0%, 100%, 0.5);
  margin: 1rem 1rem;
}
.sidebar-menu .menu.navbar-nav .nav-item .nav-link {
  display: block;
  width: 100%;
  text-align: left;
  padding: 0.65rem 1rem;
  color: hsla(0, 0%, 100%, 0.5);
  transition: all 0.3s;
}
.sidebar-menu .menu.navbar-nav .nav-item .nav-link span {
  margin-left: 0.5rem;
}
.sidebar-menu .menu.navbar-nav .nav-item .nav-link:hover, .sidebar-menu .menu.navbar-nav .nav-item .nav-link:active, .sidebar-menu .menu.navbar-nav .nav-item .nav-link.active {
  background: #152031;
  color: hsla(0, 0%, 100%, 0.8);
}
.sidebar-menu .menu.navbar-nav .nav-item .nav-link:hover i, .sidebar-menu .menu.navbar-nav .nav-item .nav-link:active i, .sidebar-menu .menu.navbar-nav .nav-item .nav-link.active i {
  font-weight: 900;
}
.sidebar-menu .collapse,
.sidebar-menu .collapsing {
  background: #131b25;
  box-shadow: 0 0.15rem 1.75rem 0 rgba(33, 37, 41, 0.15) inset;
}
.sidebar-menu .collapse .collapse-inner,
.sidebar-menu .collapsing .collapse-inner {
  min-width: 10rem;
  font-size: 0.85rem;
}
.sidebar-menu .collapse .collapse-inner .collapse-item,
.sidebar-menu .collapsing .collapse-inner .collapse-item {
  padding: 0.9rem 1.8rem;
  display: block;
  color: #3a3b45;
  text-decoration: none;
  white-space: nowrap;
  color: rgba(255, 255, 255, 0.5);
}
.sidebar-menu .collapse .collapse-inner .collapse-item:hover, .sidebar-menu .collapse .collapse-inner .collapse-item.active,
.sidebar-menu .collapsing .collapse-inner .collapse-item:hover,
.sidebar-menu .collapsing .collapse-inner .collapse-item.active {
  background: #10151c;
  color: hsla(0, 0%, 100%, 0.8);
}
.sidebar-menu .collapse .collapse-inner .collapse-item:hover i, .sidebar-menu .collapse .collapse-inner .collapse-item.active i,
.sidebar-menu .collapsing .collapse-inner .collapse-item:hover i,
.sidebar-menu .collapsing .collapse-inner .collapse-item.active i {
  font-weight: 900;
}

.student-notification ul {
  padding: 0px;
  margin: 0;
}
.student-notification ul li {
  list-style: none;
}
.student-notification ul li .drop-title {
  font-weight: 500;
  padding: 2px 20px 5px;
  border-bottom: 1px solid rgba(120, 130, 140, 0.13);
}
.student-notification ul li .nav-link {
  border-top: 1px solid rgba(120, 130, 140, 0.13);
  padding-top: 5px;
  padding-bottom: 0;
  color: #333333;
}
.student-notification ul .notification-center {
  width: 230px;
  height: 220px;
  overflow: auto;
  position: relative;
}
.student-notification ul .notification-center a {
  border-bottom: 1px solid rgba(120, 130, 140, 0.13);
  display: block;
  text-decoration: none;
  padding: 0px 15px;
}
.student-notification ul .notification-center a:hover {
  background: #f2f4f8;
}
.student-notification ul .notification-center a .notification-contnet {
  display: inline-block;
  width: 70%;
  vertical-align: middle;
  padding-left: 8px;
}
.student-notification ul .notification-center a .notification-contnet h5 {
  color: #232f3e;
  margin: 5px 0px 0;
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.student-notification ul .notification-center a .notification-contnet .mail-desc {
  font-size: 14px !important;
}
.student-notification ul .notification-center a .notification-contnet .mail-desc,
.student-notification ul .notification-center a .notification-contnet .time,
.student-notification ul .notification-center a .notification-contnet .date {
  font-size: 12px;
  display: block;
  margin: 1px 0;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #67757c;
  white-space: nowrap;
}

.header-top {
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1019607843);
}
.header-top .search {
  position: relative;
}
.header-top .search i {
  font-size: 14px;
  color: #9f9f9f;
  position: absolute;
  top: 12px;
  left: 10px;
}
.header-top .search .search-bar {
  padding-left: 35px;
}
.header-top .navbar-nav {
  align-items: center;
}
@media (min-width: 1200px) {
  .header-top .navbar-nav .nav-item {
    padding-right: 20px;
  }
  .header-top .navbar-nav .nav-item:last-child {
    padding-right: 0;
  }
}
.header-top .navbar-nav .nav-item .nav-link span i {
  font-size: 1.25rem;
}
.header-top .navbar-nav .no-arrow.dropdown.nav-item .nav-link {
  padding-top: 0;
  padding-bottom: 0;
}
.header-top .navbar-nav .profile-img {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 20px;
}
.header-top .navbar-nav .profile-img img {
  width: 35px;
  height: 35px;
}
.header-top .navbar-nav .profile-img .text .profile-name {
  font-size: 14px;
  line-height: 6px;
}
.header-top .dropdown-menu {
  border: none;
  animation-name: slideIn;
  box-shadow: 0 0.15rem 1.75rem 0 rgba(33, 37, 41, 0.15);
}
@media (min-width: 992px) {
  .header-top .dropdown-menu {
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }
}
@keyframes slideIn {
  0% {
    transform: translateY(1rem);
    opacity: 0;
  }
  100% {
    transform: translateY(0rem);
    opacity: 1;
  }
  0% {
    transform: translateY(1rem);
    opacity: 0;
  }
}

.result-modal-custom {
  position: relative;
}
.result-modal-custom .list-inline {
  display: flex;
  align-items: center;
}
.result-modal-custom .list-inline .list-inline-item {
  font-size: 16px;
}
.result-modal-custom .list-inline .list-inline-item span {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  line-height: 40px;
  text-align: center;
  display: block;
}
.result-modal-custom .list-inline .list-inline-item span i {
  border-radius: 50%;
  position: absolute;
  right: 0;
  bottom: 0;
  background: green;
}
.result-modal-custom .list-inline .list-inline-item span.success {
  color: #fff;
  background: green;
}
.result-modal-custom .list-inline .list-inline-item span.light {
  border: 1px solid rgba(214, 207, 207, 0.5019607843);
}
.result-modal-custom .list-inline .list-inline-item span.danger {
  color: #fff;
  background: red;
}
.result-modal-custom .list-inline .list-inline-item span.primary {
  color: #fff;
  background: blue;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/navbars/_navbars.scss"],"names":[],"mappings":"AACE;EAEE,qBAAA;AADJ;AAIE;EACE,8BAAA;AAFJ;AAKE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAHJ;AAKI;EACE,WAAA;EACA,kBAAA;AAHN;AAMI;EACE,6CAAA;EACA,iBAAA;AAJN;AAOI;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,6BAAA;EACA,oBAAA;AALN;AAOM;EACE,mBAAA;AALR;AAQM;EAGE,mBAAA;EACA,6BAAA;AARR;AAUQ;EACE,gBAAA;AARV;AAcE;;EAEE,mBAAA;EACA,4DAAA;AAZJ;AAcI;;EACE,gBAAA;EACA,kBAAA;AAXN;AAaM;;EACE,sBAAA;EACA,cAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,+BAAA;AAVR;AAYQ;;;EAEE,mBAAA;EACA,6BAAA;AATV;AAWU;;;EACE,gBAAA;AAPZ;;AAeA;EACE,YAAA;EACA,SAAA;AAZF;AAcE;EACE,gBAAA;AAZJ;AAcI;EACE,gBAAA;EACA,qBAAA;EACA,kDAAA;AAZN;AAeI;EACE,+CAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAbN;AAiBE;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;AAfJ;AAiBI;EACE,kDAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;AAfN;AAiBM;EACE,mBAAA;AAfR;AAkBM;EACE,qBAAA;EACA,UAAA;EACA,sBAAA;EACA,iBAAA;AAhBR;AAkBQ;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAhBV;AAmBQ;EACE,0BAAA;AAjBV;AAoBQ;;;EAGE,eAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAlBV;;AAyBA;EACE,oDAAA;AAtBF;AAwBE;EACE,kBAAA;AAtBJ;AAwBI;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAtBN;AAyBI;EACE,kBAAA;AAvBN;AA2BE;EACE,mBAAA;AAzBJ;AA4BM;EADF;IAEI,mBAAA;EAzBN;EA2BM;IACE,gBAAA;EAzBR;AACF;AA6BQ;EACE,kBAAA;AA3BV;AA2CI;EACE,cAAA;EACA,iBAAA;AAzCN;AA4CI;EACE,sCAAA;EACA,mBAAA;AA1CN;AA4CM;EACE,WAAA;EACA,YAAA;AA1CR;AA8CQ;EACE,eAAA;EACA,gBAAA;AA5CV;AAkDE;EACE,YAAA;EACA,uBAAA;EACA,sDAAA;AAhDJ;AAkDI;EACE;IACE,wBAAA;IACA,yBAAA;EAhDN;AACF;AAoDE;EACE;IACE,2BAAA;IACA,UAAA;EAlDJ;EAqDE;IACE,2BAAA;IACA,UAAA;EAnDJ;EAsDE;IACE,2BAAA;IACA,UAAA;EApDJ;AACF;;AAwDA;EACE,kBAAA;AArDF;AAuDE;EACE,aAAA;EACA,mBAAA;AArDJ;AAuDI;EACE,eAAA;AArDN;AAuDM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AArDR;AAsDQ;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;AApDV;AAuDQ;EACE,WAAA;EACA,iBAAA;AArDV;AAwDQ;EACE,mDAAA;AAtDV;AAyDQ;EACE,WAAA;EACA,eAAA;AAvDV;AA0DQ;EACE,WAAA;EACA,gBAAA;AAxDV","sourcesContent":[".sidebar-menu {\n  .sidebar-header {\n    // background: #232F3E;\n    margin-bottom: 0.8rem;\n  }\n\n  .current {\n    border-bottom: 4px solid white;\n  }\n\n  .menu.navbar-nav {\n    display: flex;\n    flex-direction: column;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none;\n\n    i {\n      width: 25px;\n      text-align: center;\n    }\n\n    hr.sidebar-divider {\n      border-top: 1px dashed hsla(0, 0%, 100%, 0.5);\n      margin: 1rem 1rem;\n    }\n\n    .nav-item .nav-link {\n      display: block;\n      width: 100%;\n      text-align: left;\n      padding: 0.65rem 1rem;\n      color: hsla(0, 0%, 100%, 0.5);\n      transition: all 0.3s;\n\n      span {\n        margin-left: 0.5rem;\n      }\n\n      &:hover,\n      &:active,\n      &.active {\n        background: #152031;\n        color: hsla(0, 0%, 100%, 0.8);\n\n        i {\n          font-weight: 900;\n        }\n      }\n    }\n  }\n\n  .collapse,\n  .collapsing {\n    background: #131b25;\n    box-shadow: 0 0.15rem 1.75rem 0 rgba(33, 37, 41, 0.15) inset;\n\n    .collapse-inner {\n      min-width: 10rem;\n      font-size: 0.85rem;\n\n      .collapse-item {\n        padding: 0.9rem 1.8rem;\n        display: block;\n        color: #3a3b45;\n        text-decoration: none;\n        white-space: nowrap;\n        color: rgba(255, 255, 255, 0.5);\n\n        &:hover,\n        &.active {\n          background: #10151c;\n          color: hsla(0, 0%, 100%, 0.8);\n\n          i {\n            font-weight: 900;\n          }\n        }\n      }\n    }\n  }\n}\n\n.student-notification ul {\n  padding: 0px;\n  margin: 0;\n\n  li {\n    list-style: none;\n\n    .drop-title {\n      font-weight: 500;\n      padding: 2px 20px 5px;\n      border-bottom: 1px solid rgba(120, 130, 140, 0.13);\n    }\n\n    .nav-link {\n      border-top: 1px solid rgba(120, 130, 140, 0.13);\n      padding-top: 5px;\n      padding-bottom: 0;\n      color: #333333;\n    }\n  }\n\n  .notification-center {\n    width: 230px;\n    height: 220px;\n    overflow: auto;\n    position: relative;\n\n    a {\n      border-bottom: 1px solid rgba(120, 130, 140, 0.13);\n      display: block;\n      text-decoration: none;\n      padding: 0px 15px;\n\n      &:hover {\n        background: #f2f4f8;\n      }\n\n      .notification-contnet {\n        display: inline-block;\n        width: 70%;\n        vertical-align: middle;\n        padding-left: 8px;\n\n        h5 {\n          color: #232f3e;\n          margin: 5px 0px 0;\n          font-size: 14px;\n          white-space: nowrap;\n          text-overflow: ellipsis;\n          overflow: hidden;\n        }\n\n        .mail-desc {\n          font-size: 14px !important;\n        }\n\n        .mail-desc,\n        .time,\n        .date {\n          font-size: 12px;\n          display: block;\n          margin: 1px 0;\n          text-overflow: ellipsis;\n          overflow: hidden;\n          color: #67757c;\n          white-space: nowrap;\n        }\n      }\n    }\n  }\n}\n\n.header-top {\n  box-shadow: 0px 3px 20px #0000001a;\n\n  .search {\n    position: relative;\n\n    i {\n      font-size: 14px;\n      color: #9f9f9f;\n      position: absolute;\n      top: 12px;\n      left: 10px;\n    }\n\n    .search-bar {\n      padding-left: 35px;\n    }\n  }\n\n  .navbar-nav {\n    align-items: center;\n\n    .nav-item {\n      @media (min-width: 1200px) {\n        padding-right: 20px;\n\n        &:last-child {\n          padding-right: 0;\n        }\n      }\n\n      .nav-link {\n        span i {\n          font-size: 1.25rem;\n\n          // &::after {\n          //   position: absolute;\n          //   content: \"\";\n          //   background-color: #f81201;\n          //   top: -3px;\n          //   right: 5px;\n          //   width: 6px;\n          //   height: 6px;\n          //   border-radius: 50%;\n          // }\n        }\n      }\n    }\n\n    .no-arrow.dropdown.nav-item .nav-link {\n      padding-top: 0;\n      padding-bottom: 0;\n    }\n\n    .profile-img {\n      border: 1px solid rgba(0, 0, 0, 0.125);\n      border-radius: 20px;\n\n      img {\n        width: 35px;\n        height: 35px;\n      }\n\n      .text {\n        .profile-name {\n          font-size: 14px;\n          line-height: 6px;\n        }\n      }\n    }\n  }\n\n  .dropdown-menu {\n    border: none;\n    animation-name: slideIn;\n    box-shadow: 0 0.15rem 1.75rem 0 rgba(33, 37, 41, 0.15);\n\n    @media (min-width: 992px) {\n      & {\n        animation-duration: 0.3s;\n        animation-fill-mode: both;\n      }\n    }\n  }\n\n  @keyframes slideIn {\n    0% {\n      transform: translateY(1rem);\n      opacity: 0;\n    }\n\n    100% {\n      transform: translateY(0rem);\n      opacity: 1;\n    }\n\n    0% {\n      transform: translateY(1rem);\n      opacity: 0;\n    }\n  }\n}\n\n.result-modal-custom {\n  position: relative;\n\n  .list-inline {\n    display: flex;\n    align-items: center;\n\n    .list-inline-item {\n      font-size: 16px;\n\n      span {\n        position: relative;\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        line-height: 40px;\n        text-align: center;\n        display: block;\n        i {\n          border-radius: 50%;\n          position: absolute;\n          right: 0;\n          bottom: 0;\n          background: green;\n        }\n\n        &.success {\n          color: #fff;\n          background: green;\n        }\n\n        &.light {\n          border: 1px solid #d6cfcf80;\n        }\n\n        &.danger {\n          color: #fff;\n          background: red;\n        }\n\n        &.primary {\n          color: #fff;\n          background: blue;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
